import { render, staticRenderFns } from "./TextImg.vue?vue&type=template&id=41429214&scoped=true"
import script from "./TextImg.vue?vue&type=script&lang=js"
export * from "./TextImg.vue?vue&type=script&lang=js"
import style0 from "./TextImg.vue?vue&type=style&index=0&id=41429214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41429214",
  null
  
)

export default component.exports